export default __webpack_public_path__ + "assets/guide.272b46fd.svg";